/**
 * Created by Peter.Fischaleck on 07.06.2016.
 */
import {MathUtils} from "./mathUtils";
import {CONSTANTS} from "./meta_data";


export class ZOrderCollisionResult {
    public zIndizes = [];
    public illegalCollisions = [];
}

export class ZOrderCollisionFinder {
    /** @var PartSelectableObjecft */
    private readonly partSelOb;
    private result;
    private readonly isClone;
    private ownCorners;

    constructor(partSelOb, isClone?, partialResult?) {
        this.partSelOb = partSelOb;
        if (typeof (partialResult) !== "undefined") {
            this.result = partialResult;
        } else {
            this.result = new ZOrderCollisionResult();
        }
        this.isClone = typeof(isClone) === "undefined" ? false : isClone;
    }

    public getZIndexCollisions() {
       this.getZIndexCollisionsWithSelObs();
        if (!this.isClone) {
            this.getResultFromClones();
        }
        this.result.zIndizes.sort(function(a,b){return a-b;});   //sortiere nach größe (da ich in den rekrusiven Aufrufen nicht darauf geachtet habe)
        return this.result;
    }

    private getZIndexCollisionsWithSelObs() {
        let i, lenI;
        const selObs              = this.partSelOb.parent.selectableObjects;
        this.ownCorners     = this.partSelOb.corners.slice(0);
        this.ownCorners[4]  = this.ownCorners[0]; //wir wollen auch die Linie vom 0ten zum 3ten Punkt

        for (i = 0, lenI =  selObs.length; i < lenI; i ++) {
            if (selObs[i] !== this.partSelOb) {
                this.getZIndizesOverlappingWithSelOb(selObs[i]);
            }            
        }       
    }

    private getResultFromClones() {
        let i, lenI, collisionSearcher;
        for (i = 0, lenI = this.partSelOb.cloneIds.length; i < lenI; i++) {
            collisionSearcher = new ZOrderCollisionFinder(this.partSelOb.parent.parent.getPartSelObById(this.partSelOb.cloneIds[i]), true, this.result);
            this.result = collisionSearcher.getZIndexCollisions();
        }
    }

    private getZIndizesOverlappingWithSelOb(selOb) {
        const extremes    = selOb.getPartCanvasMinMaxCoordinates();

        if (this.partSelOb.isDistinctFromArea(extremes)) {
            return;
        }

        if (this.selObsOverlapCompletely(extremes) ) {
            this.getZIndizesBecauseSelObsOverlap(selOb);
            return;
        }

        this.getOverlappingZIndizesByIntersectingBorders(selOb);
    }

    private getOverlappingZIndizesByIntersectingBorders(selOb) {
        let i, lenI;
        const corners = selOb.corners.slice(0);
        corners[4]  = corners[0]; //wir wollen auch die Linie vom 0ten zum 3ten Punkt

        for (i = 1, lenI = this.ownCorners.length; i < lenI; i++) {
            if (ZOrderCollisionFinder.intersectionExists(this.ownCorners[i - 1], this.ownCorners[i], corners) === true) {
                this.getZIndizesBecauseSelObsOverlap(selOb);
                return;
            }
        }
    }

    private static intersectionExists(firstCornerPoint:any, secondBorderPoint:any, corners) {
        let i, lenI, intersect;
        for (i = 1, lenI = corners.length; i < lenI; i++) {

            intersect = MathUtils.checkLineIntersection(
                firstCornerPoint,
                secondBorderPoint,
                corners[i - 1],
                corners[i]
            );
            if (intersect.onLine1 && intersect.onLine2) {
                return true;
            }
        }
        return false;
    }

    private selObsOverlapCompletely(extremes) {
        return this.partSelOb.containsArea(extremes) || this.partSelOb.isContainedInArea(extremes);
    }

    private getZIndizesBecauseSelObsOverlap(selOb) {
        const zIndex = selOb.zIndex();
        if (this.result.zIndizes.indexOf(zIndex) === -1) {
            if (selOb.keepSeparate === true) {
                this.result.illegalCollisions.push(selOb.id);
            }
            if (selOb.floating === CONSTANTS.FLOAT_FREE) {
                this.result.zIndizes.push(zIndex);
            }
        }
    }
}
